// extracted by mini-css-extract-plugin
module.exports = {"grid-container":"jsyno","headline":"_33CAG"};